import { includes } from 'lodash/fp'

export const includesKey = (listOfKeys) => (val, key) =>
  includes(key, listOfKeys)

export default includesKey
